module.exports = __webpack_public_path__ + "static/img/设备管理@2x.5d594ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设备管理@2x.png
// module id = DXXA
// module chunks = 1